export default __webpack_public_path__ + "static/media/pyramid.b7e0a2a4.png";